import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { IonicModule } from '@ionic/angular';

@Component({
    selector: 'app-card-overlay',
    templateUrl: './card-overlay.component.html',
    styleUrls: ['./card-overlay.component.scss'],
    imports: [IonicModule]
})
export class CardOverlayComponent implements OnDestroy, AfterViewInit {
  @Output()
  public closeEvent = new EventEmitter<void>();

  @Input()
  public open: Subject<void> = new Subject();

  @Input()
  public close: Subject<void> = new Subject();

  private subscriptions = new Subscription();

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  ngAfterViewInit() {
    this.subscriptions.add(
      this.close.subscribe(() => {
        this.closeCard();
      })
    );
  }

  closeCard() {
    this.closeEvent.next();
  }
}
